import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { timer } from "rxjs";

@Component({
    selector: "app-notification",
    templateUrl: "./notification.component.html",
    styleUrls: ["./notification.component.scss"],
    standalone: false
})
export class NotificationComponent implements OnInit {
  @Input() type: string = "";
  @Input() icon: string = "";
  @Input() customIcon: boolean = false;
  @Input() exit = false;
  @Input() message: string = "";
  @Input() id: string = "";
  @Input() idMessage: string = "";
  @Input() time: number | null = null;
  @Input() hyperlinkText: string = "";
  @Input() hyperlinkId: string = "";
  @Input() list: Array<{ message: string }> = [];

  @Output() hyperlink = new EventEmitter();

  showNotification = true;
  @Output() showChange = new EventEmitter();

  @Input()

  get show() {
    return this.showNotification;
  }

  set show(val) {
    if (this.time != null && val) {
      const source = timer(this.time);
      const susb = source.subscribe((f: number) => {
        this.show = false;
        susb.unsubscribe();
      });
    }
    this.showNotification = val;
    this.showChange.emit(this.showNotification);
  }

  public srcIcon: string;
  public iconSuccess: string = "../../../assets/icons/check.svg";
  public iconError: string = "../../../assets/icons/x.svg";
  public iconInfo: string = "../../../assets/icons/bulb-idea.svg";
  public iconWarning: string = "../../../assets/icons/hand.svg";
  public xIcon: string = "../../../assets/icons/x.svg";

  constructor() {}

  ngOnInit() {
    this.srcIcon = `../../../assets/icons/${this.icon}.svg`;
  }

  closeNotification() {
    this.show = false;
  }
  clickHyperlink() {
    this.hyperlink.emit();
  }
}
